module.exports = __webpack_public_path__ + "static/media/researchesNotFound.7b7daca2.png";